module.exports = __webpack_public_path__ + "static/media/item_6_3_comp.bfea90eb.png";